import React from "react";

// Subtle Māori triple-twist (Pikorua) watermark — decorative accent only.
export const Pikorua = ({ className = "", stroke = "currentColor" }) => (
  <svg viewBox="0 0 200 200" fill="none" className={className} aria-hidden="true">
    <g stroke={stroke} strokeWidth="3" strokeLinecap="round" opacity="0.9">
      <path d="M100 20 C 60 40, 40 70, 60 100 C 80 130, 120 130, 140 100 C 160 70, 140 40, 100 20 Z" />
      <path d="M100 60 C 80 75, 75 95, 90 110 C 105 125, 130 120, 140 100" />
      <path d="M60 100 C 40 130, 55 170, 100 180 C 145 170, 160 130, 140 100" />
      <path d="M100 100 C 90 120, 95 150, 100 170" />
    </g>
  </svg>
);

// Small single koru curl for inline accents.
export const KoruMark = ({ className = "", stroke = "currentColor" }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
    <path
      d="M8 40 C 8 18, 26 8, 40 14 C 30 12, 18 20, 20 32 C 21 39, 30 40, 32 33 C 33 29, 28 27, 27 31"
      stroke={stroke}
      strokeWidth="2.5"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);
